module.exports = __webpack_public_path__ + "img/logo.7fbfc005.png";